import { CANVAS_TEXT_DEFAULT_KEY, type CanvasTextColorPalette } from '../ProjectCanvas/utils/canvasTextContent'
import type { CanvasTextMarkerShapeSpec } from '../ProjectCanvas/utils/canvasTextMarkerShape'
import { TITLE_FOREGROUND, TITLE_WHITE, parseTitleColorKey, titleInkVar } from '@/src/renderer/lib/projectIcon/titlePalette'

/**
 * Der **Marker im Projekttitel**: Pinsel-Enden, leicht gewellte und raue
 * Kanten — eingestellt im Marker-Labor (`tools/marker-lab`, gewünscht
 * 2026-09-26). Ohne Trockenpinsel-Streifen: Sie lenkten zu sehr ab. Die Pinnwand behält ihre Kappen.
 * Nicht übernommen: „multiplizieren" — im Dunkelmodus würde der Marker fast schwarz.
 */
export const PROJECT_TITLE_MARKER: CanvasTextMarkerShapeSpec = {
  height: 1.2,
  overhang: 0.25,
  tilt: 0.1,
  opacity: 0.9,
  wobbleAmp: 0.015,
  waveLength: 1 * 2.2,
  rough: 0.008,
  cap: { style: 'pinsel', depth: 0.12, count: 3, irr: 0.6 },
  streaks: { count: 0, strength: 0.35, width: 0.025, length: 0.7 },
  variation: 0.4,
}

/**
 * Die Schriftfarben des **Projekttitels** (CONTEXT.md „Projekt-Kopf“): die
 * Titel-Palette mit ±3 Abstufungen. Welcher Hex-Wert gilt, hängt am Modus —
 * deshalb steht hier nur eine CSS-Variable, die `ProjectTitle.scss` je Modus
 * auf die richtige Stufe legt. `default` ist der Ton des Lebensbereichs.
 */
export const PROJECT_TITLE_PALETTE: CanvasTextColorPalette = {
  isColorKey: value => value === CANVAS_TEXT_DEFAULT_KEY || value === TITLE_FOREGROUND || value === TITLE_WHITE || parseTitleColorKey(value) !== null,
  ink: key => {
    if (key === TITLE_FOREGROUND) return 'var(--foreground)'
    if (key === TITLE_WHITE) return '#fff'
    const parsed = parseTitleColorKey(key)
    return parsed ? `var(${titleInkVar(parsed.family, parsed.offset)})` : 'var(--page-title)'
  },
  headingWeight: true,
  markerShape: PROJECT_TITLE_MARKER,
}
